<ol class="breadcrumb float-xl-right">
    <li class="breadcrumb-item">Inicio</li>
    <li class="breadcrumb-item">Administración</li>
    <li class="breadcrumb-item active">Entidades</li>
</ol>

<h1 class="page-header"><i class="fas fa-wrench"></i> Administración <small> Entidades</small></h1>


@if(!entity && !showEditEntity){
<div class="scrollable">
    <panel [noButton]="true">

        <div class="d-flex justify-content-between align-items-center mb-4">
            <input type="text" class="form-control form-control-sm w-75"
                (keyup)="filterEntities($event.target.value)" placeholder="Buscar entidad...">
            <button class="btn btn-success btn-xs" (click)="addEntity()"> <i class="fas fa-plus"></i> Nuevo</button>
        </div>

        <div class="table-responsive" style="max-height: 62vh; overflow: auto;">
        <table class="table table-sm table-striped table-hover align-middle mb-0" style="min-width: 950px;">
            <thead>
                <tr>
                    <th class="text-center">N°</th>
                    <th class="text-center">Código</th>
                    <th class="text-center">Nombre</th>
                    <th class="text-center">Grupo</th>
                    <th class="text-center">Campo</th>
                    @for(mod of moduleColumns; track mod.id){
                    <th class="text-center" title="{{mod.name}}">Auditor — {{mod.acronym}}</th>
                    }
                    <th class="text-center">Habilitado</th>
                    <th class="text-center"><i class="fas fa-cogs"></i></th>
                </tr>
            </thead>
            <tbody>
                @if(entities?.length > 0){
                @for(entity of entities; track $index){
                <tr [ngClass]="{ 'bg-danger': !entity.enabled }">
                    <td class="text-center">{{ $index + 1 }}</td>
                    <td class="text-center">{{ entity.code }}</td>
                    <td class="text-center">{{ entity.name }}</td>
                    <td class="text-center">{{ entity.group?.name }}</td>
                    <td class="text-center">{{ entity.office?.acronym }}</td>
                    @for(mod of moduleColumns; track mod.id){
                    <td class="text-center">{{ auditorFor(entity, mod.id) }}</td>
                    }
                    <td>
                        <div class="form-check form-switch d-flex justify-content-center">
                            <input class="form-check-input" type="checkbox"
                                [checked]="entity.enabled" (change)="activeDeactiveEntity(entity)" />
                        </div>
                    </td>
                    <td class="text-center text-nowrap">
                        <button class="btn btn-xs btn-ghost text-primary" (click)="setEditEntity(entity)" ngbTooltip="Editar">
                            <i class="fas fa-edit"></i>
                        </button>
                    </td>
                </tr>
                }
                } @else {
                <tr>
                    <td [attr.colspan]="7 + moduleColumns.length" class="text-center py-4 text-muted">
                        <i class="fas fa-building fs-3 mb-2 d-block"></i>
                        No hay registros para mostrar.
                    </td>
                </tr>
                }
            </tbody>
        </table>
        </div>

    </panel>
</div>
}@else{
<ng-container>
    <app-edit-entity [entity]="entity" (close)="showEditEntity = false; entity = null"
        (update)="getEntities()"></app-edit-entity>
</ng-container>
}